import {supabase} from './supabase.ts';
import {withDeadline} from './requests.ts';
import type {ObservationSnapshot} from './observations.ts';

export async function readObservations(sessionId?:string): Promise<ObservationSnapshot> {
  const r=await withDeadline(signal=>supabase.rpc('get_observation_snapshot',{p_session_id:sessionId??null}).abortSignal(signal),30_000);
  if(r.error)throw r.error;
  const data=r.data as ObservationSnapshot;
  if(data?.schema_version!=='field-feedback-v1' || !['venues','sessions','events','taps','notes','waves','bin_zones','staff_schedule','profiles','categories'].every(k=>Array.isArray((data as unknown as Record<string,unknown>)[k]))) throw new Error('The complete dataset could not be verified. Refresh to try again.');
  return data;
}
export async function excludeObservation(id: string, reason: string): Promise<void> {
  const r=await withDeadline(signal=>supabase.rpc('exclude_observation_session',{p_id:id,p_reason:reason}).abortSignal(signal));
  if(r.error)throw r.error;
  if(r.data?.id!==id || r.data?.voided_at==null)throw new Error('Exclusion could not be verified. Refresh before retrying.');
}
